



export class ZmienAdresEmailFormularz {
    public adresEmail: string;
}